exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ant-empty{\n  margin:0 8px;\n  font-size:14px;\n  line-height:22px;\n  text-align:center;\n}\n.ant-empty-image{\n  height:100px;\n  margin-bottom:8px;\n}\n.ant-empty-image img{\n  height:100%;\n}\n.ant-empty-image svg{\n  height:100%;\n  margin:auto;\n}\n.ant-empty-description{\n  margin:0;\n}\n.ant-empty-footer{\n  margin-top:16px;\n}\n.ant-empty-normal{\n  margin:32px 0;\n  color:rgba(0, 0, 0, 0.25);\n}\n.ant-empty-normal .ant-empty-image{\n  height:40px;\n}\n.ant-empty-small{\n  margin:8px 0;\n  color:rgba(0, 0, 0, 0.25);\n}\n.ant-empty-small .ant-empty-image{\n  height:35px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/less-loader/dist/cjs.js?{modifyVars:{"@primary-color":"#621816"}}!./~/antd/lib/empty/style/index.less
// module id = 946
// module chunks = 0